import React from 'react';
import { Box, Typography, Stack, Link } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const EventList = ({
    events,
    onClick,
    shouldEdit,
    shouldDelete,
    onDeleteClick,
}) => {
    return (
        <Box
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: '12px',
                marginTop: '16px',
                overflow: 'hidden',
            }}
        >
            {events.map((event, index) => (
                <Box
                    key={event.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        p: 2,
                        cursor: 'pointer',
                        borderBottom:
                            index !== events.length - 1
                                ? '1px solid #E0E0E0'
                                : 'none',
                        '&:hover': {
                            backgroundColor: '#f9f9f9',
                        },
                    }}
                    onClick={() => onClick?.(event)}
                >
                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#292929',
                        }}
                    >
                        {event.title}
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '400',
                            color: '#292929',
                        }}
                    >
                        {event.description}
                    </Typography>

                    <Stack
                        direction='row'
                        spacing={2}
                        sx={{ mt: 2, justifyContent: 'start' }}
                    >
                        {shouldEdit && (
                            <Link
                                component='button'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClick?.(event);
                                }}
                                underline='none'
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <EditOutlinedIcon fontSize='small' />
                                <Typography sx={{ ml: 0.5 }}>Editar</Typography>
                            </Link>
                        )}

                        {shouldDelete && (
                            <Link
                                component='button'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDeleteClick?.(event);
                                }}
                                underline='none'
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    color: '#1F83FF',
                                }}
                            >
                                <DeleteOutlinedIcon fontSize='small' />
                                <Typography sx={{ ml: 0.5 }}>
                                    Excluir
                                </Typography>
                            </Link>
                        )}
                    </Stack>
                </Box>
            ))}
        </Box>
    );
};

export default EventList;
